import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon, DownloadIcon, CheckCircleIcon } from 'lucide-react';
import { trackEvent } from '../utils/metaPixel';
export function FinalCTA() {
  const handleAddToCart = () => {
    trackEvent('AddToCart', {
      content_name: 'Protocolo Cero Aullidos',
      content_type: 'product',
      value: 8990,
      currency: 'ARS'
    });
  };
  return <section id="final-cta" className="py-14 md:py-32 bg-white relative overflow-hidden" data-id="element-40">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full bg-amber-50/50 blur-3xl rounded-full -z-10" data-id="element-41" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-42">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-43">
          <h2 className="text-3xl md:text-5xl font-bold text-charcoal mb-6 md:mb-8" data-id="element-44">
            Accedé ahora al <br className="hidden md:block" data-id="element-45" />
            <span className="text-amber-600" data-id="element-46">"Protocolo Cero Aullidos"</span>
          </h2>

          <div className="bg-white border-2 border-amber-200 rounded-3xl p-5 pt-10 md:p-12 shadow-2xl shadow-amber-100/50 max-w-2xl mx-auto mb-8 relative" data-id="element-47">
            <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-amber-500 text-white px-6 py-2 rounded-full font-bold text-sm tracking-wide uppercase shadow-md" data-id="element-48">
              Oferta Especial
            </div>

            <div className="flex justify-center items-baseline gap-2 mb-6" data-id="element-49">
              <span className="text-2xl text-charcoal-light font-medium" data-id="element-50">
                $
              </span>
              <span className="text-5xl md:text-6xl font-bold text-charcoal" data-id="element-51">
                8.990
              </span>
              <span className="text-xl text-charcoal-light font-medium" data-id="element-52">
                ARS
              </span>
            </div>

            <ul className="space-y-3 md:space-y-4 mb-8 md:mb-10 text-left max-w-sm mx-auto" data-id="element-53">
              <li className="flex items-center gap-3 text-charcoal-light" data-id="element-54">
                <CheckCircleIcon className="text-green-500 shrink-0" size={20} data-id="element-55" />
                <span data-id="element-56">Pago único, sin suscripciones</span>
              </li>
              <li className="flex items-center gap-3 text-charcoal-light" data-id="element-57">
                <DownloadIcon className="text-green-500 shrink-0" size={20} data-id="element-58" />
                <span data-id="element-59">Acceso inmediato a la descarga en PDF</span>
              </li>
              <li className="flex items-center gap-3 text-charcoal-light" data-id="element-60">
                <LockIcon className="text-green-500 shrink-0" size={20} data-id="element-61" />
                <span data-id="element-62">Para leer en tu celular o computadora</span>
              </li>
            </ul>

            <a href="https://amigospeludosarg.shop/cart/49114711326962:1" target="_blank" rel="noopener noreferrer" onClick={handleAddToCart} className="w-full py-4 md:py-5 px-8 bg-amber-500 hover:bg-amber-600 text-white text-lg md:text-xl font-bold rounded-2xl shadow-lg shadow-amber-500/30 transition-all hover:-translate-y-1 hover:shadow-xl flex flex-col items-center justify-center gap-1 no-underline cursor-pointer" data-id="element-63">
              <span data-id="element-64">QUIERO RECUPERAR MI PAZ Y LA DE MI PERRO</span>
            </a>

            <div className="mt-6 flex items-center justify-center gap-2 text-sm text-charcoal-light" data-id="element-65">
              <LockIcon size={16} className="text-green-600" data-id="element-66" />
              <span data-id="element-67">Tu compra es segura y el acceso es instantáneo.</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}